module.exports = __webpack_public_path__ + "static/outback-logo-e08e83f2bace586b6760c8c97355517b.png";